var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "down-arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-938.000000, -135.000000)",
    fill: "#67748E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "down-arrow",
    transform: "translate(938.000000, 135.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91769231,0.994615385 L4.61538462,4.29692308 L1.31307692,0.994615385 C1.01124701,0.7030983 0.531473248,0.707267405 0.234754942,1.00398571 C-0.0619633645,1.30070402 -0.0661324689,1.78047778 0.225384615,2.08230769 L4.07153846,5.92846154 C4.37192296,6.22875534 4.85884627,6.22875534 5.15923077,5.92846154 L9.00538462,2.08230769 C9.20535122,1.88917348 9.28554815,1.60317085 9.21515166,1.33422514 C9.14475517,1.06527942 8.93472058,0.855244834 8.66577486,0.784848341 C8.39682915,0.714451848 8.11082652,0.794648781 7.91769231,0.994615385 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.91f06e629024566240e41693f68c9719.svg";
export { ForwardRef as ReactComponent };